import VueBaseController from '../vue_base'
 
export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/qc_blank_products/index.vue') }
} 